import * as z from "zod/v4";

export const getGuidance = {
  name: "getGuidance" as const,
  input: z.object({}),
  output: z.object({ guidance: z.string().nullable() }),
};
